/**
 * Lightweight logger utility.
 *
 * - In development: forwards to console.warn / .error / .debug as expected.
 * - In production: warn/error are silenced (we don't ship dev noise to users);
 *   debug is a hard no-op.
 *
 * The goal isn't to make the app silent — it's to ensure none of the
 * operational error-handling paths bleed into the production console.
 * For real telemetry, swap the body of `error()` for a Sentry/posthog call.
 */
const isDev =
  typeof process !== 'undefined' &&
  process.env &&
  process.env.NODE_ENV !== 'production';

const logger = {
  debug: (...args) => {
    if (isDev && typeof console !== 'undefined' && console.debug) console.debug(...args);
  },
  warn: (...args) => {
    if (isDev && typeof console !== 'undefined' && console.warn) console.warn(...args);
  },
  error: (...args) => {
    if (isDev && typeof console !== 'undefined' && console.error) console.error(...args);
  },
};

export default logger;
